import { useCallback, useEffect, useMemo, useState } from 'react';

import sendRequest from '../../../service/sendRequest';
import callApi from '../../../service/callApi';
import getAiChatsOptionsFromArray from '../../../utils/getAiChatsOptionsFromArray';

const useAIChatsOptions = ({ search }) => {
  const [localOptions, setLocalOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const searchedOptions = useMemo(() => {
    return localOptions?.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
  }, [localOptions, search]);

  const handleLoadAIChats = useCallback(async () => {
    setIsLoading(true);

    const response = await sendRequest(() => callApi.get('/api/ai/playground/ai-chats'));
    const options = getAiChatsOptionsFromArray(response.data);
    setLocalOptions(options);

    setIsLoading(false);
  }, []);

  useEffect(() => {
    handleLoadAIChats();
  }, [handleLoadAIChats]);

  return { options: searchedOptions, isLoading };
};

export default useAIChatsOptions;
